<div *ngIf="auths">
  <micro-picklist title="Authorizations" idField="auth" displayField="auth" [all]="auths" [(selectedIds)]="selectedAuths" (selectedIdsChange)="onNgModelChange($event)"></micro-picklist>
</div>
